import { useEffect } from "react";

export default function HubspotForms() {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.innerHTML = `
      hbspt.forms.create({
        region: "na1",
        portalId: "40821606",
        formId: "cdcb1847-46f9-49df-823f-b328a29704d5",
        target: "#hubspotForm",
      });
    `;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <section className="mt-4">
      <div id="hubspotForm"></div>
    </section>
  );
}
